import api from "./api";

export async function getSlides() {
  const response = await api.get(`/documents/base`);
  return response?.data || [];
}
